import React from "react"
import moment from "moment"
import CrudGrid from "../../views/app/modules/crudGrid"

export default (context) => {
  const M = "admInfirmary."
  const crudAdmMedical = () => {
    return (
      <CrudGrid
        ctx={ctx => context.ctxAdmMedical = ctx}
        match={{ path: '/app/admMedical' }}
        onlyCrud={true}
      />
    ) 
  }

  let fields = [
    {
      col: 3,
      name: "superSectionId",
      value: "",
      type: "select",
      label: "main.grade",
      opts: {
        style: 'float-label',
        path: "/admSuperSection/get?pick=true"
      },
      renderIf: (ctx) => { return !context.state.idItemSelected }
    },
    {
      col: 3,
      name: "sectionId",
      value: "",
      type: "select",
      label: "main.section",
      parent: "superSectionId",
      opts: {
        style: 'float-label',
        path: () => { return "/admSection/get?pick=true&parentId=" + context.state.form.superSectionId }
      },
      renderIf: (ctx) => { return !context.state.idItemSelected }
    },
    {
      col: 6,
      name: "userId",
      value: "",
      type: "select",
      label: "main.patient",
      rules: 'required',
      parent: "sectionId",
      opts: {
        style: 'float-label',
        searchOnline: true,
        withImg: true,
        path: () => { return "/admStudent/get?pick=true&enrolled=1" + (context.state.form?.sectionId ? ("&sectionId=" + context.state.form?.sectionId) : "") }
      }
    },
    {
      name: "timeIn",
      value: "",
      type: "hidden",
    },
    {
      name: "timeOut",
      value: "",
      type: "hidden",
    },
    {
      col: 3,
      name: "timeInTxt",
      value: "",
      type: "text",
      label: `${M}entryTime`,
      rules: ['required', {regex:'^([01]?[0-9]|2[0-3]):[0-5][0-9]$'}],
      placeholder: "00:00",
      opts: {
        style: 'float-label',
        default: () => moment().format('HH:mm'),
      }
    },
    {
      col: 3,
      name: "timeOutTxt",
      value: "",
      type: "text",
      label: `${M}exitTime`,
      rules: ['required', {regex:'^([01]?[0-9]|2[0-3]):[0-5][0-9]$'}],
      placeholder: "00:00",
      opts: {
        style: 'float-label'
      }
    },
    /*
    {
      col: 6,
      name: "name",
      value: null,
      type: "text",
      label: "Incidente",
      rules: 'required',
      opts: {
        style: 'float-label'
      }
    },
    */
    {
      col: 6,
      name: "symptomId",
      value: "",
      type: "select",
      label: "main.symptom",
      rules: 'required',
      opts: {
        style: 'float-label',
        searchOnline: true,
        path: () => { return "/admInfirmaryValues/get?type=SYM" },
        setOutput: v => v
      }
    },
    {
      col: 12,
      name: "desc",
      value: null,
      type: "textarea",
      label: "main.desc",
      rules: 'required',
      opts: {
        style: 'float-label'
      }
    },
    {
      col: 4,
      name: "arrivedFrom",
      value: "",
      type: "select",
      label: `${M}cameFrom`,
      rules: 'required',
      opts: {
        style: 'float-label',
        path: () => { return "/admInfirmaryValues/get?type=OUT" },
        remap: (r) => {
          if (r.data.Results) r.data.Results = r.data.Results.map(e => ({ ID: e.name, name: e.name }))
          return r
        }
      }
    },
    {
      col: 4,
      name: "outcomeId",
      value: "",
      type: "select",
      label: `${M}departedTo`,
      rules: 'required',
      opts: {
        style: 'float-label',
        path: () => { return "/admInfirmaryValues/get?type=OUT" }
      }
    },
    {
      col: 4,
      name: "departedTo",
      value: "",
      type: "select",
      label: `${M}transportMedium`,
      rules: 'required',
      opts: {
        style: 'float-label',
        path: () => { return "/admInfirmaryValues/get?type=MOB" },
        remap: (r) => {
          if (r.data.Results) r.data.Results = r.data.Results.map(e => ({ ID: e.name, name: e.name }))
          return r
        }
      }
    },
    {
      col: 4,
      name: "createdDate",
      value: null,
      type: "datetime",
      label: `${M}incidentDate`,
      opts: {
        style: 'float-label'
      },
      disabled: true,
      renderIf: (ctx) => { return context.state.idItemSelected }
    },
    {
      col: 4,
      name: "updatedDate",
      value: null,
      type: "datetime",
      label: "main.lastModification",
      opts: {
        style: 'float-label'
      },
      disabled: true,
      renderIf: (ctx) => { return context.state.idItemSelected }
    },
    {
      col: 4,
      name: "staffName",
      value: null,
      type: "text",
      label: `${M}medicalStaff`,
      opts: {
        style: 'float-label'
      },
      disabled: true,
      renderIf: (ctx) => { return context.state.idItemSelected }
    },
    /*
    {
      col: 8,
      name: "prescription",
      value: null,
      type: "text",
      label: "Prescripción",
      rules: 'required',
      opts: {
        style: 'float-label'
      }
    },
    */
    {
      col: 4,
      colxs: 4,
      name: "photo1",
      value: "",
      type: "dropzone",
      label: "main.attachment",
      isDoc: false,
      rules: 'ext:jpeg,jpg,png',
      opts: {
        path: ()=> "admInfirmary/file",
        accept: '.jpeg,.jpg,.png',
        output: true
      }
    },
    {
      col: 4,
      colxs: 4,
      name: "photo2",
      value: "",
      type: "dropzone",
      label: "main.attachment",
      isDoc: false,
      rules: 'ext:jpeg,jpg,png',
      opts: {
        path: ()=> "admInfirmary/file",
        accept: '.jpeg,.jpg,.png',
        output: true
      }
    },
    {
      col: 4,
      colxs: 4,
      name: "photo3",
      value: "",
      type: "dropzone",
      label: "main.attachment",
      isDoc: false,
      rules: 'ext:jpeg,jpg,png',
      opts: {
        path: ()=> "admInfirmary/file",
        accept: '.jpeg,.jpg,.png',
        output: true
      }
    }
  ]

  if (context.props.userAdmin.write.includes("admMedical")) {
    fields.push({
      col: 12,
      name: "grid",
      value: "",
      type: "component",
      opts: {
        component: crudAdmMedical
      }
    }, {
      col: 12,
      name: "btn1",
      label: "Ver Ficha Médica",
      type: "button",
      onClick: (ctx) => {
        context.ctxAdmMedical.getDataById(ctx.state.userId)
      },
      renderIf: ctx => ctx.state.userId 
    })
  }

  return {
    config: {
      pageSize: 40,
      list: false
    },

    actions: {
      create: {
        reloadGrid: true
      },
      edit: true,
      delete: true,
      print: false,
      export: true,
      search: true
    },

    extras: {
      /*items: [
        {id: 0, icon: 'simple-icon-refresh', name: 'Sincronizar con ISAMS', onClick: () => { 
          context.props.setLoader(true)
          _axios
            .post(`/admInfirmary/sync`)
            .then(r => {
              context.props.setLoader(false)
              if (r.status >= 0) {
                console.log(r)
              }
              if (r.msg) NotificationManager[r.status >= 0 ? "success" : "error"](r.msg, "", 5000, null, null, 'outline')
            }).catch(e => context.props.setLoader(false))
        }}
      ],
      maxItems: 1,
      maxActions: 1,
      */
    },

    filter: {
      fields: [
        {
          name: "superSectionId",
          value: null,
          type: "select",
          label: "main.grade",
          opts: {
            style: 'float-label',
            path: "/admSuperSection/get?pick=true"
          }
        },
        {
          name: "sectionId",
          value: "",
          type: "select",
          label: "main.section",
          parent: "superSectionId",
          opts: {
            style: 'float-label',
            path: () => { return "/admSection/get?pick=true&parentId=" + context.state.formFilter.superSectionId }
          }
        },
        {
          name: "userId",
          value: "",
          type: "select",
          label: "main.student",
          rules: 'required',
          parent: "sectionId",
          opts: {
            style: 'float-label',
            searchOnline: true,
            withImg: true,
            path: () => { return "/admStudent/get?pick=true&enrolled=1&sectionId=" + context.state.formFilter.sectionId }
          }
        },
        {
          type: "daterange",
          range: {
            value: 0
          }
        },
       /* {
          name: "syncStatus",
          value: null,
          type: "select",
          label: "Estado sincronización",
          opts: {
            style: 'float-label',
            items: [
              {
                value: null,
                label: "Todos"
              },
              {
                value: 0,
                label: "Pendientes"
              },
              {
                value: 1,
                label: "Sincronizados"
              },
              {
                value: -1,
                label: "Con error"
              },
            ]
          }
        }*/
      ],
      buttons: [
        {
          name: "btnFilter",
          label: "main.applyFilter",
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    form: {
      setValuesBeforePost: (values) => {
        delete values.createdDate
        delete values.updatedDate
        delete values.staffIds
        values.prescription = "-"
        values.name = values.symptomId.label
        values.symptomId = values.symptomId.value
        values.timeIn = (context.state.idItemSelected ? moment(values.timeIn).format('YYYY-MM-DD ') : moment().format('YYYY-MM-DD ')) + values.timeInTxt
        values.timeOut = (context.state.idItemSelected ? moment(values.timeOut).format('YYYY-MM-DD ') : moment().format('YYYY-MM-DD ')) + values.timeOutTxt
        return values
      },
      remapOne: (r) => {
        if (r.status >= 0) {
          r.data.userId = {value: r.data.userId, label: r.data.patient}
          r.data.symptomId = {value: r.data.symptomId, label: r.data.symptomName}
          r.data.outcomeId = {value: r.data.outcomeId, label: r.data.outcomeName}
          r.data.timeInTxt = moment(r.data.timeIn).format('HH:mm')
          r.data.timeOutTxt = moment(r.data.timeOut).format('HH:mm')
        }
        return r
      },
      // detailGrid: () => {
      //   return {
      //     module: 'admMedical',
      //     filterBy: () => { return { userId: context.state.form?.userId } }
      //   }
      // },
      fields: fields
    },

    columns: [
      {
        Header: "main.ID",
        accessor: "ID"
      },
      {
        Header: `main.gradeAndSection`,
        accessor: "sectionTag",
      },
      {
        Header: "main.patient",
        accessor: "patient",
      },
      {
        Header: "main.symptom",
        accessor: "symptomName",
      },
      {
        Header: "main.outcome",
        accessor: "outcomeName",
      },
      {
        Header: "main.date",
        accessor: "updatedDate",
        isDate: true
      },
      /*{
        Header: "ISAMS",
        accessor: "syncStatus",
        type: 'chip',
        chips: {
          '-1': {text:'Error',color:'red'},
          '0': {text:'Pending',color:'orange'},
          '1': {text:'Synced',color:'green'}
        }
      }*/
    ]
  }
}